export default "__VITE_ASSET__DLvuS9Cr__"